import {ChangeEvent, FC} from 'react';
import {Box, MenuItem, Select, Typography} from '@mui/material';
import {FormattedMessage} from 'react-intl';
import {TableRowCounterType} from './TableRowCounter.types';
import {counterWrapperSx, selectSx} from './TableRowCounter.sx';

// The one list every table reads: TableLayout feeds all 33 list pages, and the two IAM sections use
// the counter directly. 500 is here because an export-sized page beats paging through five screens;
// the server enforces no upper bound, so the only limit is what the browser will render.
const PAGE_SIZE_OPTIONS = [10, 25, 50, 100, 200, 500];

export const TableRowCounter: FC<TableRowCounterType> = ({
                                                             handleChangeRowsNumber,
                                                             defaultValue,
                                                         }) => {
    const value = PAGE_SIZE_OPTIONS.includes(defaultValue) ? defaultValue : PAGE_SIZE_OPTIONS[0];

    return (
        <Box sx={counterWrapperSx}>
            <Select
                sx={selectSx}
                value={value}
                onChange={(e) =>
                    handleChangeRowsNumber({
                        target: {value: String(e.target.value)},
                    } as ChangeEvent<HTMLInputElement>)
                }
                MenuProps={{
                    PaperProps: {
                        sx: {
                            mt: 0.5,
                            borderRadius: '10px',
                            boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
                        },
                    },
                }}
            >
                {PAGE_SIZE_OPTIONS.map((option) => (
                    <MenuItem key={option} value={option} sx={{fontSize: '13px'}}>
                        {option}
                    </MenuItem>
                ))}
            </Select>
            <Typography variant="caption">
                <FormattedMessage id="entriesPerPage"/>
            </Typography>
        </Box>
    );
};
